import React from 'react';
import { motion } from 'framer-motion';
import { DarkGreenTexture } from './DarkGreenTexture';
import { Landmark, HeartPulse, Cpu, Scale, ArrowRight, Handshake } from 'lucide-react';
type Industry = {
  label: string;
  icon: React.ElementType;
  title: string;
  description: string;
};
const INDUSTRIES: Industry[] = [{
  label: 'Financial Services',
  icon: Landmark,
  title: 'Brief the desk before standup',
  description: 'Giga pulls from Slack, email, and your CRM to surface deal movement, client risk, and what needs a decision — before the morning meeting.'
}, {
  label: 'Healthcare',
  icon: HeartPulse,
  title: 'Keep every team compliant',
  description: 'Giga tracks policy and protocol changes across your docs and channels, then tells each team exactly what they need to action.'
}, {
  label: 'Technology',
  icon: Cpu,
  title: 'Ship without status meetings',
  description: 'Giga digests GitHub, Linear, and Slack into a clear daily picture of what shipped, what is blocked, and who owns what.'
}, {
  label: 'Legal & Compliance',
  icon: Scale,
  title: 'Turn folders into exhibits',
  description: 'Point Giga at a folder of documents and get a chronologically organized set with descriptive titles and a risk assessment.'
}];
export function EnterpriseIndustries() {
  return <section className="relative w-full bg-[#2B211A] text-white py-28 md:py-40 overflow-hidden" data-id="element-929">
      <DarkGreenTexture glow="top-right" data-id="element-930" />
      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-931">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-24" data-id="element-932">
          <div className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-8" data-id="element-933">
            <Handshake size={22} className="text-[#F97316]" data-id="element-934" />
          </div>
          <h2 className="font-title text-4xl md:text-6xl font-bold tracking-tight text-white" data-id="element-935">
            Supports every industry
          </h2>
        </motion.div>

        {/* Industry columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4" data-id="element-936">
          {INDUSTRIES.map((industry, i) => {
          const Icon = industry.icon;
          return <motion.div key={industry.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className={`flex flex-col px-0 md:px-8 py-8 md:py-0 ${i !== 0 ? 'md:border-l border-white/10 border-t md:border-t-0' : ''}`} data-id="element-937">
                {/* Category label */}
                <div className="flex items-center gap-2.5 mb-10" data-id="element-938">
                  <Icon size={18} className="text-white/50" data-id="element-939" />
                  <span className="text-sm text-white/60" data-id="element-940">
                    {industry.label}
                  </span>
                </div>

                {/* Featured use case */}
                <h3 className="font-title text-2xl font-bold text-white mb-4 leading-snug" data-id="element-941">
                  {industry.title}
                </h3>
                <p className="text-white/60 leading-relaxed mb-8 flex-1" data-id="element-942">
                  {industry.description}
                </p>

                {/* Learn more */}
                <a href="#" className="inline-flex items-center gap-1.5 self-start text-sm font-semibold text-[#F97316] hover:text-white transition-colors group" data-id="element-943">
                  Learn more
                  <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" data-id="element-944" />
                </a>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}